.modalInner,
.modalOverlay {
    z-index: var(--mantine-priority-high);
}

.modalContent {
    border-radius: 16px;
    z-index: var(--mantine-priority-high);
    background-color: var(--mantine-color-dark-5);
    /* Solution until we solve for responsiveness */
    @media screen and (max-height: 768px) {
        max-height: 39.675rem;
    }
}

.modalTextareaContainer {
    background-color: var(--mantine-color-dark-7);
    border: 1px solid var(--mantine-color-dark-4);
    border-radius: 8px;
    &:focus-within {
        border-color: var(--mantine-color-asurion-5);
    }
}

.modalTextarea {
    font-size: var(--mantine-font-size-xs);
    line-height: 1.5rem;
    color: var(--mantine-color-gray-4);
    background-color: transparent;
    border: none;
    &:disabled {
        background-color: transparent;
        color: var(--mantine-color-gray-1);
    }
}

.notificationRoot {
    padding-right: 0rem;
    background-color: transparent;
}

.pillRoot {
    background-color: var(--mantine-color-primary-3);
    padding: 0px 9px;
    border-radius: 0.25rem;
}

.pillLabel {
    color: black;
    font-weight: var(--mantine-font-weight-heavy);
    line-height: 20px;
}

.loadingAnimation {
    height: 3rem;
    width: 3rem;
}

.tempTimeline {
    position: absolute;
    top: auto;
    gap: 0;
    bottom: 6rem;
    padding: 12px 24px;
    height: fit-content;
}

.sendSummaryButton {
    color: white;
    &:disabled {
        color: var(--mantine-color-gray-6);
        background: var(--mantine-color-gray-7);
    }
}

.notificationWrapper {
    margin: 0rem 1rem 0.65rem 1rem;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.defaultBg {
    background-color: color-mix(in srgb, var(--mantine-color-gray-6), transparent 70%);
    cursor: unset;
}

.errorBg {
    background-color: color-mix(in srgb, var(--mantine-color-red-9), transparent 70%);
}

.brandedBg {
    background-color: color-mix(in srgb, var(--mantine-color-asurion-4), transparent 70%);
}
